module.exports = __webpack_public_path__ + "dk.svg?fab04e8bfd38e1c61bfea514b73dca8c";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/dk.svg
// module id = 1041
// module chunks = 27